import axios from "axios";
import { persistor } from "../store";
import Cookies from "js-cookie";

const PUBLIC_API_URL = process.env.REACT_APP_API_URL;


const defaultOptions = {
  baseURL: `${PUBLIC_API_URL}`,
  headers: {
    "Content-Type": "application/json",
  },
};

// Dummy Projects Data
let dummyProjects = [
  { _id: "1", name: "Dabur", iconId: "dabur", color: "#1B5C29",sessions:[
    {
      _id:"694e62627524e500218b5ade",
      title:"Session 1",
       name: "Dabur",
       projectId:"1",
      iconId:"session1",
      color:"#1B5C29"
    },
     {
      _id:"688b6e6bb76e4200207b44b2",
      title:"Session 2",
      iconId:"session2",
       name: "Dabur",
       projectId:"1",
      color:"#1B5C29"
    }
  ] }
];

// export const createProject = async (data) => {
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       const newProject = {
//         _id: Date.now().toString(),
//         ...data,
//       };
//       dummyProjects.push(newProject);
//       resolve({ status: 1, data: newProject, message: "Project created successfully" });
//     }, 500);
//   });
// };

export const getProjects = async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ status: 1, data: dummyProjects });
    }, 500);
  });
};

let instance = axios.create(defaultOptions);

// Set the AUTH token for any request
instance.interceptors.request.use(function (config) {
  let token = Cookies.get("idToken");
  config.headers.Authorization = token ? `Bearer ${token}` : "";
  return config;
});

instance.interceptors.response.use(
  function (response) {
    const { data } = response || {};
    return data;
  },
  function (error) {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      const currentUrl = window.location.href;
      if (!currentUrl.includes("auth")) {
        Cookies.remove("idToken", { path: "/" });
        Cookies.remove("tokenExpiry", { path: "/" })
        sessionStorage.clear();
        persistor.purge();
        window.location.href = "/auth";
      }
    }
    const response = error?.response?.data || error;
    return Promise.reject(response);
  }
);

export const setQueryMessage = (message) => ({
  type: "ADD_QUERY_MESSAGE",
  payload: message,
});

export const setProjectQueryMessage = (message) => ({
  type: "ADD_PROJECT_QUERY_MESSAGE",
  payload: message,
});
export const setChatSessionId = (id) => ({
  type: "ADD_QUERY_SESSION_ID",
  payload: id,
});
export const setProjectChatsessionId = (id) => ({
  type: "ADD_PROJECT_CHAT_SESSION_ID",
  payload: id,
});

// Action Creators
export const fetchChatsRequest = () => ({ type: "FETCH_CHATS_REQUEST" });
export const fetchChatsSuccess = (chats) => ({
  type: "FETCH_CHATS_SUCCESS",
  payload: chats,
});
export const setChats = (error) => ({
  type: "FETCH_CHATS_FAILURE",
  payload: error,
});

export const setPage = (page) => ({
  type: "SET_PAGE_CHAT",
  payload: page,
});

export const setSelectedChat = (chat) => ({
  type: "SET_SELECTED_CHAT",
  payload: chat,
});
export const setSelectedProjectChat = (chat) => ({
  type: "SET_SELECTED_PROJECT_CHAT",
  payload: chat,
});
export const clearSelectedChat = () => ({ type: "CLEAR_SELECTED_CHAT" });
export const clearSelectedProjectChat = () => ({ type: "CLEAR_SELECTED_PROJECT_CHAT" });

export const addNewChat = (chat) => ({
  type: "ADD_NEW_CHAT",
  payload: chat,
});

// Thunk Actions
export const fetchRecentChats = (data) => async (dispatch) => {
  dispatch(fetchChatsRequest());
  const queryString = new URLSearchParams(data)?.toString();
  const response = await instance({
    method: "GET",
    url: `/api/v1/user/getChats?${queryString}`,
  });

  return response;
};

export const createNewChat = (data, email) => async (dispatch) => {

  const response = await instance({
    method: "POST",
    url: "/api/v1/user/createChat",
    data,
    headers: {
      Botemail: email,
    },
  });

  if (response.status === 1) {
    dispatch(addNewChat(response.data));
  }
  return response;
};

// Existing API functions
export const getInboxChatBySessionId = (data) => {
  const queryString = new URLSearchParams(data)?.toString();
  return instance({
    method: "GET",
    url: `/api/v1/user/getChats?${queryString}`,
  });
};

// Existing API functions
export const getChatBySessionId = (data) => {
  const queryString = new URLSearchParams(data)?.toString();
  return instance({
    method: "GET",
    url: `/api/v1/user/getSessions/${queryString}`,
  });
};

// Existing API functions
export const getChatBySessionIdForProject = (data) => {
  
  return instance({
    method: "GET",
    url: `/api/v1/user/getSessions/${data}`,
  });
};

export const getDocumentSessionId = (sessionId) => {
  return instance({
    method: "GET",
    url: `/api/v1/user/getSessions/${sessionId}`,
  });
};

export const sendChat = (data, email) => {
  return instance({
    method: "POST",
    url: "/api/v1/user/createChat",
    data,
    headers: {
      Botemail: email,
    },
  });
};

export const uploadFiles = (data) => {
  return instance({
    method: "POST",
    url: "/api/v1/upload/uploadFiles",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const setUser = (user) => ({
  type: "SET_USER",
  payload: user,
});

export const clearUser = () => ({
  type: "CLEAR_USER",
});

// voice AI
export const setMode = (mode) => ({
  type: "SET_MODE",
  payload: mode,
});

export const setTranscript = (text) => ({
  type: "SET_TRANSCRIPT",
  payload: text,
});

export const setIsMicOn = (isMicOn) => ({
  type: "SET_MIC",
  payload: isMicOn,
});

export const resetVoice = () => ({
  type: "RESET_VOICE",
});
export const generateImage = (data) => {
  return instance({
    method: "POST",
    url: "/api/v1/user/generateImage",
    data,
  });
};
export const generateVideo = (data) => {
  return instance({
    method: "POST",
    url: "/api/v1/user/generateVideo",
    data,
  });
};
export const generateAudio = (data) => {
  return instance({
    method: "POST",
    url: "/api/v1/user/generateAudio",
    data,
  });
};
export const getContentHistory = (data) => {
  const queryString = new URLSearchParams(data)?.toString();
  return instance({
    method: "GET",
    url: `/api/v1/user/getContentChats?${queryString}`,
  });
};

export const savePrompt = (data) => {
  return instance({
    method: "POST",
    url: "/api/v1/user/createPrompt",
    data,
  });
};

export const getPromptsList = (data) => {
  const queryString = new URLSearchParams(data)?.toString();
  return instance({
    method: "GET",
    url: `/api/v1/user/getPrompts?${queryString}`,
  });
};

export const getGlobalPromptsList = (data) => {
  const queryString = new URLSearchParams(data)?.toString();
  return instance({
    method: "GET",
    url: `/api/v1/user/getGlobalPrompts?${queryString}`,
  });
};

export const getGlobalSearchList = (data) => {
  const queryString = new URLSearchParams(data)?.toString();
  return instance({
    method: "GET",
    url: `/api/v1/user/search?${queryString}`,
  });
};

export const getShareLink = (data) => {
  return instance({
    method: "GET",
    url: `/api/v1/user/shareChat/${data}`,
  });
};

export const getShareChat = (data) => {
  return instance({
    method: "GET",
    url: `/share/${data}`,
  });
};

export const deletePrompt = (dynamicId) => {
  return instance({
    method: "DELETE",
    url: `/api/v1/user/deletePrompt/${dynamicId}`,
  });
};

export const createDeepSearchChat = (data) => {
  return instance({
    method: "POST",
    url: "/api/v1/user/createDeepsearchChat",
    data,
  });
};

export const getDeepSearchChatStatus = (chatId) => {
  return instance({
    method: "GET",
    url: `/api/v1/user/getChatStatus/${chatId}`,
  });
};

export const updateUserDisclaimerStatus = () => {
  return instance({
    method: "PATCH",
    url: `/api/v1/user/updateDisclaimer`,
    data: { isDisclaimerAccepted: true },
  });
};

export const getAllPinCode = () => {
  return instance({
    method: "GET",
    url: `/api/v1/user/getUserPincodes?page=1&limit=100`,
  });
};

export const savePinCode = (data) => {
  return instance({
    method: "POST",
    url: "/api/v1/user/savePincodes",
    data,
  });
};

export const createWeatherForcastChat = (data) => {
  return instance({
    method: "POST",
    url: "/api/v1/user/forcast",
    data,
  });
};


export const getWeatherForcastHistory = (data) => {
  const queryString = new URLSearchParams(data)?.toString();
  return instance({
    method: "GET",
    url: `/api/v1/user/forcastHistory?${queryString}`,
  });
};


export const getWeatherForcastChatStatus = (chatId) => {
  return instance({
    method: "GET",
    url: `api/v1/user/forcastStatus?jobId=${chatId}`,
  });
};

export const deletePinCode = (id) => {
  return instance({
    method: "DELETE",
    url: `/api/v1/user/deleteUserPincode/${id}`,
  });
};

export const uploadPptKnowledgeBase = (data) => {
  return instance({
    method: "POST",
    url: "/api/v1/upload/document-to-slidespeak",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const generatePresentationOutline = (data) => {
  return instance({
    method: "POST",
    url: "/api/v1/presentation/generateOutline",
    data,
  });
};

export const generateFinalPresentation = (data) => {
  return instance({
    method: "POST",
    url: "/api/v1/presentation/generatePpt",
    data,
  });
};

export const checkPPTGenerationStatus = (data) => {
  return instance({
    method: "POST",
    url: "/api/v1/presentation/checkPptStatus",
    data,
  });
};

export const imageAndVideoModels = () => {
  return instance({
    method: "GET",
    url: "/api/v1/AiModel/ai-models?active=true",
  });
};

export const generateVideoV2 = (data) => {
  return instance({
    method: "POST",
    url: "/api/v2/user/generateVideo",
    data,
  });
};

export const checkVideoGenerationStatus = (id) => {
  return instance({
    method: "GET",
    url: `/api/v2/user/getGenerationStatus/${id}`,
  });
};


export const projectAgentChat = (data) => {
  return instance({
    method: "POST",
    url: "/api/v2/User/generic_agent_chat",
    data,
  });
};

export const attachProjectFiles = (data) => {
  return instance({
    method: "POST",
    url: "/api/v2/user/upload_files_project",
    data,
  });
};

export const financeAgentChat = (data) => {
  return instance({
    method: "POST",
    url: `/api/v2/User/finance_agent_chat`,
    data,
  });
};

export const createProject = (data) => {
  return instance({
    method: "POST",
    url: "/api/v2/User/create_project",
    data,
  });
};


export const marketingAgentRequest = (data) => {
  return instance({
    method: "POST",
    url: "/api/v2/User/marketting_agent_request",
    data,
  });
};

export const marketingAgentStatusCheck = (data) => {
  return instance({
    method: "GET",
    url: `/api/v2/User/marketting_agent_response?projectId=${data.projectId}&request_id=${data.requestId}`,
  });
};

export const getProjectDetails = (data) => {
  return instance({
    method: "GET",
    url: `/api/v2/User/project/${data.projectId}`,
  });
};

export const updateFilesInProject = (data) => {
  return instance({
    method: "POST",
    url: "/api/v2/user/update_project_files",
    data,
  });
};

export const generateSoraAndGenTurboVideo = (data) => {
  return instance({
    method: "POST",
    url: "/api/v2/user/generateVideoUnified",
    data,
  });
};

export const checkSoraVideoGenerationStatus = (id) => {
  return instance({
    method: "GET",
    url: `/api/v2/user/video/status/sora/${id}`,
  });
};

export const checkGenTuroVideoGenerationStatus = (id) => {
  return instance({
    method: "GET",
    url: `api/v2/user/video/status/gen4/${id}`,
  });
};

// Meeting Transcription APIs
export const submitFileForTranscription = (data) => {
  return instance({
    method: "POST",
    url: "/api/v2/User/get_transcriber_id",
    data,
  });
};

export const getTranscriptionStatus = (jobId) => {
  return instance({
    method: "GET",
    url: `/api/v2/User/transcribe_status?job_id=${jobId}`,
  });
};

export const generateTranscriptionSummary = (data) => {
  return instance({
    method: "POST",
    url: "/api/v2/User/summarize_transcription",
    data,
  });
};

export const downloadChatMedia = ({ chatId, mediaUrl }) => {
  return instance({
    method: "POST",
    url: "/api/v1/user/downloadChatMedia",
    data: { chatId, mediaUrl },
    responseType: "blob",
    skipAuthRedirect: true,
  });
};